import { Outlet, useLocation } from 'react-router-dom';
import { Header } from './Header';
import { Footer } from './Footer';
import WhatsAppButton from './WhatsAppButton';
import LeaveReviewButton from './LeaveReviewButton';
import { useContentProtection } from '../lib/content-protection';
import { ContentProtectionOverlay } from './ContentProtectionOverlay';
import { SeoHead } from './SeoHead';
import { SeoJsonLd } from './SeoJsonLd';

export function Layout() {
  const { pathname } = useLocation();
  const protectGallery =
    pathname.startsWith('/portfolio') || pathname.startsWith('/transfer');

  useContentProtection({ enabled: protectGallery });

  return (
    <div className="min-h-screen flex flex-col">
      <SeoHead />
      <SeoJsonLd />
      {protectGallery && <ContentProtectionOverlay />}
      <Header />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
      <WhatsAppButton />
      <LeaveReviewButton />
    </div>
  );
}

